module.exports = "<li class=\"nav-item\">\n  <a (click)=\"navigateToSearch()\"\n     data-se-id=\"editEventLink\"\n     class=\"nav-link active\">\n    <i class=\"glyph-calendar nav-link-addon\"></i>\n    <span class=\"item-text\">{{ eventTitle | translate }}</span>\n    <i class=\"nav-link-addon glyph-close\"></i>\n  </a>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-menu/event-menu.component.html
// module id = tzTa
// module chunks = 0